import { unit } from '@ant-design/cssinjs';
const genRadiusStyle = token => {
  const {
    componentCls,
    tableRadius
  } = token;
  return {
    ["".concat(componentCls, "-wrapper")]: {
      [componentCls]: {
        // https://github.com/ant-design/ant-design/issues/39115#issuecomment-1362314574
        ["".concat(componentCls, "-title, ").concat(componentCls, "-header")]: {
          borderRadius: "".concat(unit(tableRadius), " ").concat(unit(tableRadius), " 0 0")
        },
        ["".concat(componentCls, "-title + ").concat(componentCls, "-container")]: {
          borderStartStartRadius: 0,
          borderStartEndRadius: 0,
          // https://github.com/ant-design/ant-design/issues/41975
          ["".concat(componentCls, "-header, table")]: {
            borderRadius: 0
          },
          'table > thead > tr:first-child': {
            'th:first-child, th:last-child, td:first-child, td:last-child': {
              borderRadius: 0
            }
          }
        },
        '&-container': {
          borderStartStartRadius: tableRadius,
          borderStartEndRadius: tableRadius,
          'table > thead > tr:first-child': {
            '> *:first-child': {
              borderStartStartRadius: tableRadius
            },
            '> *:last-child': {
              borderStartEndRadius: tableRadius
            }
          }
        },
        '&-footer': {
          borderRadius: "0 0 ".concat(unit(tableRadius), " ").concat(unit(tableRadius))
        }
      }
    }
  };
};
export default genRadiusStyle;